import { buildStatusMessages } from '../../../interfaces';
import { BuildRequestStatus } from '@amzn/awsdev-docs-virtual-smiley-conference-typescript-client';
import Badge from '@amzn/awsui-components-console/badge';
import React from 'react';

export const BuildStatusBadge = (props: { status: BuildRequestStatus }) => (
  <Badge color={buildStatusMessages[props.status].color}>
    Status: {buildStatusMessages[props.status].text}
  </Badge>
);
